module.exports = __webpack_public_path__ + "static/media/insulinresistance-Figure6-L.c8b00701.jpg";